import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { saveRequestToAddFood } from "../../../../features/mobile/mealSlice";
import { useNavigate } from "react-router-dom";
import HeadCont from "../../components/common/HeadCont";
import MenuBar from "../../components/common/MenuBar";
import PhotoCard from "../../components/common/PhotoCard";
import Btn from "../../components/common/Btn";
import Dialog from "../../components/common/Dialog";
import { resizeFile } from "../../../../common/util/base";

const RequestToAddFood = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { loginInfo } = useSelector((state) => state.commonApp);
  const navigate = useNavigate();
  const [addFoodData, setAddFoodData] = useState({
    foodName: "",
    memo: "",
    camera: [],
  });
  const [loadedImage, setLoadedImage] = useState(null);
  const onAddFoodData = (e) =>
    setAddFoodData({ ...addFoodData, [e.target.name]: e.target.value });
  const [openDialog, setOpenDialog] = useState(false);

  const titleFn = (title) => {
    return <h2 className="text-caption1_600 text-gray_160">{title}</h2>;
  };

  const descFn = (desc) => {
    return <h2 className="text-caption1_400 text-gray_160">{desc}</h2>;
  };

  const onAddThumbnail = async (e) => {
    let reader = new FileReader(); // Use FileReader API to read image
    let resize = await resizeFile(e.target.files[0]); // Read file with reader first
    reader.readAsDataURL(resize);
    setAddFoodData({ ...addFoodData, camera: [resize] }); // Read file with reader first
    reader.onload = (e) => {
      // Event handler after photo upload
      setLoadedImage(e.target.result); // Put data into img src for image preview
      e.target.value = ""; // Reset to detect same file upload
    };
  };

  const onSaveRequestToAddFood = () => {
    let params = {
      userId: loginInfo.userId,
      title: addFoodData.foodName,
      content: addFoodData.memo,
      files: addFoodData.camera,
    };
    dispatch(saveRequestToAddFood(params))
      .unwrap()
      .then((res) => {
        if (res.ok) {
          setOpenDialog(true);
          setAddFoodData({ foodName: "", memo: "", camera: [] });
          setLoadedImage(null);
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    // prettier-ignore
    <>
        <HeadCont leftIcon={'no icon'} rightIcon={'close'} onRightAction={() => navigate(-1)} />
        <section className='px-6 py-4 mt-14 mb-28'>
            <h2 className='text-subtitle3 text-gray_180'>{t('meals:food_request.report_missing_food')}</h2>
            <p className='text-body3_400 text-gray_160'>{t('meals:food_request.food_not_registered')}</p>
            <div className='mt-8 space-y-8'>
                <div className='space-y-6'>
                    <div>
                        {titleFn(t('meals:food_request.food_name_label'))}
                        <textarea onChange={(e) => onAddFoodData(e)} className='w-full h-[66px] appearance-none border border-gray_80 rounded-md pl-4 py-4 focus:outline-none text-body2_500l text-black'
                            name='foodName' placeholder={t('meals:food_request.food_name_placeholder')}>
                        </textarea>
                        {descFn(t('meals:food_request.food_name_example'))}
                    </div>
                    <div>
                        {titleFn(t('meals:food_request.content_label'))}
                        <textarea onChange={(e) => onAddFoodData(e)} className='w-full h-[66px] appearance-none border border-gray_80 rounded-md pl-4 py-4 focus:outline-none text-body2_500l text-black'
                            name='memo' placeholder={t('meals:food_request.content_placeholder')}>
                        </textarea>
                    </div>
                    <div>
                        {!loadedImage && <>
                            {titleFn(t('meals:food_request.photo_attachment'))}
                            <PhotoCard onAddThumbnail={onAddThumbnail} option={true} />
                        </>}
                        {!loadedImage && descFn(t('meals:food_request.photo_help'))}
                        {loadedImage &&
                            <div id='image_container' className='relative max-w-[327px] rounded-md text-body_2 text-gray_40 border'>
                                <img src={loadedImage} alt={t('meals:food_request.food_image')} className='w-[100%] h-auto' />
                                <span className='absolute w-8 h-8 top-2 right-2'>
                                    <img onClick={() => { setAddFoodData({ ...addFoodData, camera: [] }); setLoadedImage(null); }} src='/images/mobile/icon/close_circle.svg' alt={t('meals:food_request.close_button')} /></span>
                            </div>}
                    </div>
                </div>
                <Btn bgColor={'bg-main'} textColor={'text-white'} borderColor={'border border-main'} title={t('meals:food_request.save')} active={!addFoodData.foodName ? 'ready' : 'on'} onAction={onSaveRequestToAddFood} />
            </div>
        </section>
        {openDialog && <Dialog innerClass={'py-4 pl-6 pr-5'} btnClass={'mt-[17px]'} title={t('meals:food_request.request_complete_title')} desc={t('meals:food_request.request_complete_message')}
            onRightBtnAction={() => { window.scrollTo(0, 0); navigate(-1) }} onCoverAction={() => { window.scrollTo(0, 0); navigate(-1) }} />}
        <MenuBar />
    </>
  );
};

export default RequestToAddFood;
